export default __webpack_public_path__ + "static/media/image_paneNew.d8120e09.png";